"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _useWebChatUIContext2 = _interopRequireDefault(require("./useWebChatUIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useInternalRenderMarkdownInline() {
  var _useWebChatUIContext = (0, _useWebChatUIContext2.default)(),
      internalRenderMarkdownInline = _useWebChatUIContext.internalRenderMarkdownInline;

  return internalRenderMarkdownInline;
}

var _default = useInternalRenderMarkdownInline;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC91c2VJbnRlcm5hbFJlbmRlck1hcmtkb3duSW5saW5lLmpzIl0sIm5hbWVzIjpbInVzZUludGVybmFsUmVuZGVyTWFya2Rvd25JbmxpbmUiLCJpbnRlcm5hbFJlbmRlck1hcmtkb3duSW5saW5lIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFQSxTQUFTQSwrQkFBVCxHQUEyQztBQUN6Qyw2QkFBeUMsb0NBQXpDO0FBQUEsTUFBUUMsNEJBQVIsd0JBQVFBLDRCQUFSOztBQUVBLFNBQU9BLDRCQUFQO0FBQ0Q7O2VBRWNELCtCIiwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlV2ViQ2hhdFVJQ29udGV4dCBmcm9tICcuL3VzZVdlYkNoYXRVSUNvbnRleHQnO1xuXG5mdW5jdGlvbiB1c2VJbnRlcm5hbFJlbmRlck1hcmtkb3duSW5saW5lKCkge1xuICBjb25zdCB7IGludGVybmFsUmVuZGVyTWFya2Rvd25JbmxpbmUgfSA9IHVzZVdlYkNoYXRVSUNvbnRleHQoKTtcblxuICByZXR1cm4gaW50ZXJuYWxSZW5kZXJNYXJrZG93bklubGluZTtcbn1cblxuZXhwb3J0IGRlZmF1bHQgdXNlSW50ZXJuYWxSZW5kZXJNYXJrZG93bklubGluZTtcbiJdfQ==